document.addEventListener('DOMContentLoaded', function () {
    function updateAddToCartButton() {
        var addToCartButton = document.querySelector('button[name="add"]')
        var selectElement = document.querySelector('.pplr_select')

        if (addToCartButton && selectElement) {
            var selectedOption =
                selectElement.options[selectElement.selectedIndex]
            var selectedOptionValue = selectedOption
                ? selectedOption.value.trim()
                : null

            if (!selectedOptionValue || selectedOptionValue === 'None') {
                addToCartButton.disabled = true
                addToCartButton.textContent = 'Customize Product'
            } else {
                addToCartButton.disabled = false
                addToCartButton.textContent = 'Add to Cart'
            }
        }
    }

    function setupSelectListener() {
        var selectElement = document.querySelector('.pplr_select')

        if (selectElement) {
            selectElement.addEventListener('change', function () {
                updateAddToCartButton()
            })
        }
    }

    function createCustomizeButtonFunctionality() {
        var addToCartButton = document.querySelector('button[name="add"]')

        if (addToCartButton) {
            addToCartButton.addEventListener('click', function (event) {
                if (addToCartButton.disabled) {
                    var targetDiv = document.querySelector(
                        '#pplr-7421555441873'
                    )
                    if (targetDiv) {
                        event.preventDefault()
                        targetDiv.scrollIntoView({ behavior: 'smooth' })
                        var selectElement =
                            document.querySelector('.pplr_select')
                        if (selectElement) {
                            selectElement.focus()
                        }
                    }
                }
            })
        }
    }

    function initialize() {
        var addToCartButton = document.querySelector('button[name="add"]')
        var selectElement = document.querySelector('.pplr_select')

        if (addToCartButton && selectElement) {
            updateAddToCartButton()
            setupSelectListener()
            createCustomizeButtonFunctionality()
        } else {
            // Retry until the elements are available
            setTimeout(initialize, 100)
        }

        // Disable the slider if applicable
        disableSliderIfNoSlide()
    }

    initialize()
})
